module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-valentine-left-8a19ddc7893d97763db48ae31b053183.svg";